module.exports = __webpack_public_path__ + "img/diary.519dfbd5.svg";